export const formatText = (value?: string): string => {
  if (!value) {
    return '';
  }

  return value
    .toLocaleLowerCase('sv-SE')
    .split(/\s+/)
    .filter(Boolean)
    .map(word => word.charAt(0).toLocaleUpperCase('sv-SE') + word.slice(1))
    .join(' ');
};
